import Slider from 'react-slick';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import toHref, { getTestimonial } from '../tools/fetcher';
import { classNames } from '../tools/helpers';

export default function TestimonialSlider() {
    const [testimonials, setTestimonials] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [nextSlide, setNextSlide] = useState(null);
    const [maxSlide, setMaxSlide] = useState(0);

    const pathImg = (imgName) =>
        toHref(
            `/wp-content/plugins/react-plugin/react-app/build/assets/${imgName}.svg`,
        )

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };

    const Slide = useCallback(
        ({ testy }) =>
            testy ? (
                <div className={'bg-white rounded-[20px] mr-4 sm:mr-10 space-y-7 max-w-[500px]'}>
                    <p className={'text-lg sm:text-2xl text-primary-green-101'}>
                        {testy?.description}
                    </p>
                    <div className={'flex items-center gap-6'}>
                        {testy?.imageSrc && (
                            <img
                                src={testy.imageSrc}
                                alt={testy?.imageAlt || testy?.name}
                                className={
                                    'h-[48px] w-[48px] object-contain rounded-full'
                                }
                            />
                        )}
                        <div>
                            <h1
                                className={
                                    'font-bold leading-7 text-base text-primary-green-103'
                                }
                            >
                                {testy?.name}
                            </h1>
                            <p className={'leading-7 text-base text-primary-gray-100'}>
                                {testy?.address}
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                <div>NOT FOUND</div>
            ),
        [],
    );

    const settings = {
        // autoplay: true,
        autoplaySpeed: 10000,
        infinite: false,
        speed: 700,
        slidesToShow: 2,
        slidesToScroll: 1,
        accessibility: false,
        // adaptiveHeight: true,
        swipeToSlide: true,
        // prevArrow: '<span class="slickArrow slickArrow--prev"></span>',
        // nextArrow: '<span class="slickArrow slickArrow--next"></span>',
        responsive: [
            {
                autoplay: true,
                breakpoint: 640,
                settings: {
                    centerMode: true,
                    centerPadding: '24px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        beforeChange: (current, nextS) => {
            setCurrentSlide(nextS);
            setNextSlide(nextS)
        },
        afterChange: current => {
            setMaxSlide(Math.max(nextSlide, current))
        }
    };

    useEffect(() => {
        getTestimonial().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    name: d?.title?.rendered,
                    address: d?.testimonial_details?.address,
                    imageSrc: d?.testimonial_details?.image_src,
                    imageAlt: d?.testimonial_details?.image_alt,
                    description: d?.testimonial_details?.description,
                }));
                setTestimonials(dt);
            }
        });
    }, []);

    return (
        <div className={'relative mt-4 sm:mt-[60px]'}>
            {testimonials.length > 1 && (
                <div className={'absolute hidden gap-x-6 right-0 -top-[120px] sm:flex'}>
                    <button
                        className={classNames('flex h-[48px] items-center justify-center rounded-lg w-[48px]',
                            currentSlide === 0 ? 'bg-primary-gray-99' : 'bg-primary-green-100')
                        }
                        onClick={previous}
                        disabled={currentSlide === 0}
                    >
                        <img src={pathImg('arrowLeft')} alt={'arrow left'} className={'h-[24px] w-[24px]'} />
                    </button>
                    <button
                        className={classNames('flex h-[48px] items-center justify-center rounded-lg w-[48px]',
                            nextSlide === maxSlide ? 'bg-primary-gray-99' : 'bg-primary-green-100')
                        }
                        onClick={next}
                        disabled={nextSlide === maxSlide}
                    >
                        <img src={pathImg('arrowRight')} alt={'arrow right'} className={'h-[24px] w-[24px]'} />
                    </button>
                </div>
            )}
            <div className={'sm:col-span-2 overflow-hidden relative'}>
                <div className="w-[calc(100%+32px)] sm:w-[calc(100%+40px)] -ml-2 sm:ml-0">
                    {testimonials.length > 0 && (
                        testimonials.length === 1 ? (
                            <div className={'flex items-center justify-start px-6 sm:px-0'}>
                                <Slide key={0} testy={testimonials[0]} />
                            </div>
                        ) : (
                            <Slider {...settings} ref={slider => { sliderRef = slider; }}>
                                {testimonials.map((testy, index) => (
                                    <Slide key={index} testy={testy} />
                                ))}
                            </Slider>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}
